'use client'

import React, { JSX } from 'react'
import createWidget from '@/widgets/create-widget'
import { PhotoIcon } from '@heroicons/react/24/solid'
import TrustFactorBannerSchema, {
  TrustFactorBannerProps,
  TrustFactorBannerDefaultValues,
  TrustFactor,
} from './schema'
import TrustFactorBanner from '@/components/RevampedLanding/TrustFactorBanner'

export function TrustFactorBannerWidget(props: TrustFactor) {
  const { trustFactorBanner } = props
  // Replace with actual TrustFactorBanner component import and usage
  return <TrustFactorBanner trustFactorData={trustFactorBanner} />
}

export default createWidget<TrustFactor>({
  formType: TrustFactorBannerSchema,
  render(props): JSX.Element {
    return <TrustFactorBannerWidget {...props} />
  },
  id: 'Landing.Page.TrustFactorBanner',
  name: 'Landing Trust Factor Banner',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: TrustFactorBannerDefaultValues,
})
